const getRestaurantClosedStatusMessageCode = closedStatus => {
  let messageCode;
  switch (closedStatus) {
    case 3001:
      messageCode = 3010;
      break;
    case 3009:
      messageCode = 3011;
      break;
    case 3002:
      messageCode = 3012;
      break;
    default:
      messageCode = 3013;
      break;
  }
  return messageCode;
};

export default getRestaurantClosedStatusMessageCode;
